import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MasterSolutionModel } from 'src/app/models/preliminaries/master-solution.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MasterSolutionSelectTableModel } from 'src/app/models/tables/preliminaries/master-solution-select-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterSolutionService {

  constructor(private _httpClient: HttpClient) { }

  changeStateAsync(masterSolutionId: number): Observable<MasterSolutionModel> {
    return this._httpClient.put<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.ChangeStateAsync}/${masterSolutionId}`,
      null);
  }

  createAsync(MasterSolutionModel: MasterSolutionModel): Observable<MasterSolutionModel> {
    return this._httpClient.post<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.CreateAsync}`,
      MasterSolutionModel);
  }

  deleteAsync(masterSolutionId: number): Observable<MasterSolutionModel> {
    return this._httpClient.delete<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.DeleteAsync}/${masterSolutionId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllMasterSolutionsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetAllMasterSolutionsWithPaginationAsync}`,
      filters, { params: params });
  }

  getByIdAsync(masterSolutionId: number): Observable<MasterSolutionModel> {
    return this._httpClient.get<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetByIdAsync}/${masterSolutionId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetColumnsForGeneralConsultationAsync}`);
  }

  getColumnsMasterSolutionSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetColumnsMasterSolutionSelection}`);
  }

  getFirstMasterSolutionByKeysAsync(branchId: number): Observable<MasterSolutionModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetFirstMasterSolutionByKeys}`,
      { params: params }
    );
  }

  getLastMasterSolutionByKeysAsync(branchId: number): Observable<MasterSolutionModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetLastMasterSolutionByKeys}`,
      { params: params }
    );
  }

  getMasterSolutionByKeysAsync(branchId: number, consecutive: number): Observable<MasterSolutionModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetMasterSolutionByKeys}`,
      { params: params }
    );
  }

  getMasterSolutionsForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<MasterSolutionSelectTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant)
    return this._httpClient.post<PagedResponseModel<MasterSolutionSelectTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetMasterSolutionsForSelection}`,
      filters, { params: params }
    );
  }

  getNextMasterSolutionByKeysAsync(branchId: number, consecutive: number): Observable<MasterSolutionModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetNextMasterSolutionByKeys}`,
      { params: params }
    );
  }

  getPreviusMasterSolutionByKeysAsync(branchId: number, consecutive: number): Observable<MasterSolutionModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.GetPreviusMasterSolutionByKeys}`,
      { params: params }
    );
  }

  updateAsync(masterSolutionContract: MasterSolutionModel): Observable<MasterSolutionModel> {
    return this._httpClient.put<MasterSolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.masterSolution.UpdateAsync}`,
      masterSolutionContract);
  }
}
